import Geocode from "react-geocode";
 
// Geocode.setApiKey(process.env.REACT_APP_FIREBASE_API_KEY);
Geocode.setApiKey("AIzaSyAJA0esCg6gB0rUBBm6iBmcSIanrW4GAQ4");
Geocode.setLanguage("en");
Geocode.enableDebug();

export default Geocode;